import Loading from '@/common/components/Loading';
import { WrapperWithScroll } from '@/common/styles/Wrappers';
import { getQueueGuessingRows } from './helpers/getQueueGuessingRows';
import Table from '@/common/components/Table';
import SearchBox from './components/SearchBox';
import useNotDeliveredPackagesReport from './hooks/useNotDeliveredPackagesReport';

const COLUMNS = [
	'No',
	'Client Name',
	'Client Email',
	'Waybill Number',
	'Paxy Internal Number Number',
	'Current Status',
	'Lms Sent At',
	'Delivered No Payment At',
	'Courier Id',
	'Provider',
	'Actions',
];

const NotDeliveredPackagesReport = () => {
	const hook = useNotDeliveredPackagesReport();

	return (
		<>
			{hook.isLoading && <Loading />}
			<WrapperWithScroll>
				<SearchBox hook={hook} />
				{hook?.data && (
					<Table
						className='styled-table'
						raws={getQueueGuessingRows(hook.data, hook.couriers)}
						headers={COLUMNS}
					/>
				)}
			</WrapperWithScroll>
		</>
	);
};

export default NotDeliveredPackagesReport;
